import { getYYYYMMDDWithHyphen, isValidDate } from '@shared/lib/utils/time'

export const fullDateDisplay = (text: unknown): string =>
  isValidDate(text) ? getYYYYMMDDWithHyphen(text) : `${text}`
